// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserAccountCommunication} from './digital-user-account-communication';

export const DigitalUserAccountItem = t.struct({
    uuid: t.String,
    userName: t.maybe(t.String),
    firstName: t.maybe(t.String),
    lastName: t.maybe(t.String),
    generation: t.maybe(t.String),
    formattedName: t.maybe(t.String),
    communication: t.maybe(DigitalUserAccountCommunication),
    digitalAccountStatus: t.maybe(t.String),
    isSuccess: t.Boolean,
    errorMessage: t.maybe(t.String)
}, {
    defaultProps: {
        uuid: '',
        userName: '',
        firstName: '',
        lastName: '',
        generation: '',
        formattedName: '',
        communication: new DigitalUserAccountCommunication({}),
        digitalAccountStatus: '',
        isSuccess: true,
        errorMessage: ''
    },
    name: 'DigitalUserAccountItem',
    strict: true
});
